import { makeStyles } from '@mui/styles';
import { COLORS } from '../../../../EatClubTheme';

const useStyles = makeStyles(
  (theme) => ({
    loyaltyModal: {
      display: 'flex',
      maxWidth: '920px',
      width: '100%',
      color: COLORS.SMOKE,
      gap: '24px',
      fontSize: '14px',
      lineHeight: 'auto',

      '@media (max-width: 890px)': {
        flexDirection: 'column',
        flexWrap: 'wrap',
      },
    },
    left: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      minWidth: '380px',
    },
    right: {
      maxWidth: '380px',
    },
    heading: {
      fontSize: '36px',
      fontWeight: 500,
      lineHeight: '40px',
      color: theme.colors.charcoal,
    },
    subHeading: {
      fontSize: '18px',
      fontWeight: 500,
      color: theme.colors.charcoal,
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    modalBody: {},
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },

    label: {
      color: theme.colors.black,
      textTransform: 'uppercase',
      backgroundColor: '#FCFCCF',
      fontWeight: theme.fontWeights.medium,
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',
      height: '24px',
      padding: '0 12px',
      borderRadius: '12px',
      letterSpacing: 1.5,
    },
    image: {
      maxWidth: '400px',
    },
  }),
  { name: 'LoyaltyModal' },
);

export default useStyles;

export const modalInputStyle = {
  maxWidth: '920px',
  width: '100%',
  color: COLORS.SMOKE,
  maxHeight: 'min(800px, calc(100dvh - 20px))',

  button: {
    backgroundColor: COLORS.BRAND_YELLOW,
    color: COLORS.CHARCOAL_TRANSPARENT,
  },
};
